














import {Component} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import ManageCodCustomerTable from "@/modules/managecodcustomer/components/ManageCodCustomerTable/index.vue";
import {ManageCodStore} from "@/modules/managecodcustomer/store";
import {PAGE_SIZE_OPTIONS} from "@/shared/constant";
import TableToExcel from "@linways/table-to-excel";
import ManageCodCustomerExcel from "@/modules/managecodcustomer/components/ManageCodCustomerExcel/index.vue";


const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 80,
    },
    {
        title: "Ngày phát hành",
        dataIndex: "createdDate",
        key: "createdDate",
        width: 150,
        ellipsis: true
    },
    {
        title: "Mã vận đơn",
        dataIndex: "ladingCode",
        key: "ladingCode",
        width: 150,
        ellipsis: true
    },
    {
        title: "Mã đơn hàng",
        dataIndex: "orderCode",
        key: "orderCode",
        width: 120,
        ellipsis: true
    },
    {
        title: "Đại diện gửi",
        dataIndex: "locationFrom.name",
        key: "locationFromName",
        width: 150,
        ellipsis: true
    },
    {
        title: "Nội dung hàng",
        dataIndex: "boxContent",
        key: "boxContent",
        width: 150,
        ellipsis: true,
    },
    {
        title: "Thu hộ",
        dataIndex: "codMoney",
        key: "codMoney",
        scopedSlots: {customRender: "codMoney"},
        width: 150,
        ellipsis: true
    },
    {
        title: "Tổng cước",
        dataIndex: "totalFee",
        key: "totalFee",
        scopedSlots: {customRender: "totalFee"},
        width: 150,
        ellipsis: true
    },
    {
        title: "Thu NN",
        dataIndex: "receiverCollect",
        key: "receiverCollect",
        scopedSlots: {customRender: "receiverCollect"},
        width: 150,
        ellipsis: true
    },
    {
        title: "Trả KH",
        dataIndex: "senderPay",
        key: "senderPay",
        scopedSlots: {customRender: "senderPay"},
        width: 150,
        ellipsis: true
    }
];

@Component({
    name: 'ManageCodCustomerNotYetPay',
    components: {
        ManageCodCustomerExcel,
        ManageCodCustomerTable,
    }
})
export default class extends mixins(CommonMixin) {
    idExcel = 'table-excel-cod-not-pay';
    titleExcel = 'Danh sách đơn chưa thu';
    columns = columns;
    isExporting = false;
    billLadingsExcel = [];
    get billLadings() {
        return ManageCodStore.notPayIds.map(id => ManageCodStore.notPayData[id]);
    }

    get pagination() {
        return {
            current: ManageCodStore.notPayMeta.page,
            pageSize: ManageCodStore.notPayMeta.limit,
            total: ManageCodStore.notPayMeta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bản ghi`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        const params = {
            ...ManageCodStore.notPayParams,
            page: pagination.current,
            limit: pagination.pageSize
        }
        ManageCodStore.paramNotPayManageCodChange(params);
    }

    async exportExcel() {
        this.isExporting = true;
        this.billLadingsExcel = await ManageCodStore.exportExcelCodNotPay({ ...ManageCodStore.notPayParams, page: 1 });
        this.isExporting = false;
        setTimeout(() => {
            TableToExcel.convert(document.getElementById(this.idExcel), {
                name: `Danh sách đơn.xlsx`,
                sheet: {
                    name: "Sheet 1"
                }
            }, 800);
        })
    }
}
